import React, { useEffect, useState } from 'react'

import {
  Upload, message, Button, Row, Col, Table, Spin, Tabs, PageHeader, Divider,
} from 'antd'
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons'

import { format } from 'date-fns'

import NumberFormat from 'react-number-format'

import Cookies from 'js-cookie'

import { fetch, fetchDownload } from '../../utils/fetch'

const { TabPane } = Tabs
const { Column } = Table

const endpoint = process.env[`REACT_APP_ENDPOINT_${process.env.REACT_APP_ENV}`]

const TabTable = ({ materialData, activityData, materialActivityData }) => (
  <Tabs defaultActiveKey="1">
    <TabPane tab="Material" key="1">
      <Table dataSource={materialData} size="small" scroll={{ x: 1500 }}>
        <Column title="Raw Material Code" dataIndex="rawMaterialCode" key="rawMaterialCode" width={150} fixed="left" render={(text) => text || '-'} />
        <Column title="Description" dataIndex="productionDesc" key="productionDesc" width={250} ellipsis fixed="left" render={(text) => text || '-'} />
        <Column title="Base Material" dataIndex="baseMaterial" align="center" key="baseMaterial" width={150} render={(text) => text || '-'} />
        <Column title="Color" dataIndex="colorCode" key="colorCode" width={100} align="center" render={(text) => text || '-'} />
        <Column title="Thickness" dataIndex="thickness" key="thickness" width={100} align="center" render={(text) => text || '-'} />
        <Column title="Textured Faces" dataIndex="texturedFaces" key="texturedFaces" width={150} align="center" render={(text) => text || '-'} />
        <Column title="Ready Made ML" dataIndex="readyMadeMl" key="readyMadeMl" width={150} align="center" render={(text) => text || '-'} />
        <Column title="Cost" dataIndex="cost" key="cost" width={50} align="center" render={(text) => text || '-'} />
        <Column title="Waste" dataIndex="waste" key="waste" width={100} align="center" render={(text) => text || '-'} />
        <Column title="Direct Labor" dataIndex="dl" key="dl" width={100} align="center" render={(text) => text || '-'} />
        <Column title="Over Head" dataIndex="oh" key="oh" width={100} align="center" render={(text) => text || '-'} />
        <Column title="ManageMent Fee" dataIndex="mgt" key="mgt" width={150} align="center" render={(text) => text || '-'} />
        <Column title="Margin" dataIndex="margin" key="margin" width={100} align="center" render={(text) => text || '-'} />
        <Column title="Packing" dataIndex="packing" key="packing" width={100} align="center" render={(text) => text || '-'} />
        <Column title="GP" dataIndex="gp" key="gp" width={50} align="center" render={(text) => text || '-'} />
        <Column title="SC" dataIndex="sc" key="sc" width={50} align="center" render={(text) => text || '-'} />
        <Column title="TAX" dataIndex="tax" key="tax" width={50} align="center" render={(text) => text || '-'} />
        <Column title="IDF Price" dataIndex="idfPrice" key="idfPrice" width={100} align="right" render={(text) => <NumberFormat thousandSeparator fixedDecimalScale displayType="text" value={text || 0} />} />
        <Column title="ILM Price" dataIndex="ilmPrice" key="ilmPrice" width={100} align="right" render={(text) => <NumberFormat thousandSeparator fixedDecimalScale displayType="text" value={text || 0} />} />
        <Column title="Created At" dataIndex="createdAt" key="createdAt" width={150} render={(text) => format(new Date(text), 'dd/MM/yyyy HH:mm')} />
      </Table>
    </TabPane>
    <TabPane tab="Activity" key="2">
      <Table dataSource={activityData} size="small" scroll={{ x: 1500 }}>
        <Column title="Activity Code" dataIndex="activityCode" key="activityCode" width={150} fixed="left" render={(text) => text || '-'} />
        <Column title="Description" dataIndex="activityDesc" key="activityDesc" width={250} ellipsis fixed="left" render={(text) => text || '-'} />
        <Column title="Cost" dataIndex="cost" key="cost" width={50} align="center" render={(text) => text || '-'} />
        <Column title="Unit" dataIndex="unit" key="unit" width={100} align="center" render={(text) => text || '-'} />
        <Column title="Waste" dataIndex="waste" key="waste" width={100} align="center" render={(text) => text || '-'} />
        <Column title="Direct Labor" dataIndex="dl" key="dl" width={100} align="center" render={(text) => text || '-'} />
        <Column title="Over Head" dataIndex="oh" key="oh" width={100} align="center" render={(text) => text || '-'} />
        <Column title="ManageMent Fee" dataIndex="mgt" key="mgt" width={150} align="center" render={(text) => text || '-'} />
        <Column title="Margin" dataIndex="margin" key="margin" width={100} align="center" render={(text) => text || '-'} />
        <Column title="Packing" dataIndex="packing" key="packing" width={100} align="center" render={(text) => text || '-'} />
        <Column title="GP" dataIndex="gp" key="gp" width={50} align="center" render={(text) => text || '-'} />
        <Column title="SC" dataIndex="sc" key="sc" width={50} align="center" render={(text) => text || '-'} />
        <Column title="TAX" dataIndex="tax" key="tax" width={50} align="center" render={(text) => text || '-'} />
        <Column title="IDF Price" dataIndex="idfPrice" key="idfPrice" width={100} align="right" render={(text) => <NumberFormat thousandSeparator fixedDecimalScale displayType="text" value={text || 0} />} />
        <Column title="ILM Price" dataIndex="ilmPrice" key="ilmPrice" width={100} align="right" render={(text) => <NumberFormat thousandSeparator fixedDecimalScale displayType="text" value={text || 0} />} />
        <Column title="Created At" dataIndex="createdAt" key="createdAt" width={150} render={(text) => format(new Date(text), 'dd/MM/yyyy HH:mm')} />
      </Table>
    </TabPane>
    <TabPane tab="Material+Activity" key="3">
      <Table dataSource={materialActivityData} size="small">
        <Column title="Raw Material Code" dataIndex="rawMaterialCode" key="rawMaterialCode" width={150} render={(text) => text || '-'} />
        <Column title="Activity Code" dataIndex="activityCode" key="activityCode" width={150} render={(text) => text || '-'} />
        <Column title="Description" dataIndex="commercialDesc" key="commercialDesc" width={250} ellipsis render={(text) => text || '-'} />
        <Column title="Created At" dataIndex="createdAt" key="createdAt" width={150} render={(text) => format(new Date(text), 'dd/MM/yyyy HH:mm')} />
      </Table>
    </TabPane>
  </Tabs>
)

const Material = ({ name }) => {
  const [MaterialList, setMaterialList] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(
    () => {
      getDataMaterial()
    },
    [],
  )

  const getDataMaterial = () => {
    setIsLoading(true)
    fetch({
      url: '/management/material',
    }).then((res) => {
      if (res.data?.success) {
        setMaterialList(res.data?.data)
      }
      setIsLoading(false)
    })
  }

  const DownloadMaterial = () => {
    setIsLoading(true)
    fetchDownload({
      url: '/management/material/download',
      fileName: `material_activity_${format(new Date(), 'dd-MM-yyyy')}.xlsx`,
    }).then((res) => {
      if (res.success) {
        message.success('Download Success')
      } else {
        message.error(res.message)
      }
    })
    setIsLoading(false)
  }

  const props = {
    name: 'file',
    action: `${endpoint}/management/material/upload`,
    accept: 'application/xlsx',
    headers: {
      authorization: Cookies.get(`oms-token-${process.env.REACT_APP_ENV}`),
    },
    onChange(info) {
      setIsLoading(true)
      if (info.file.status !== 'uploading') {
        setIsLoading(false)
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`)
        getDataMaterial()
        setIsLoading(false)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
        setIsLoading(false)
      }
    },
    showUploadList: false,
  }

  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <PageHeader
          ghost={false}
          title={name}
          extra={(
            <Row gutter={[16]}>
              <Col>
                <Upload {...props}>
                  <Button icon={<UploadOutlined />} type="primary">Upload</Button>
                </Upload>
              </Col>
              <Col>
                <Button icon={<DownloadOutlined />} onClick={() => DownloadMaterial()}>Download</Button>
              </Col>
            </Row>
          )}
        >
          <Divider />
          <TabTable
            materialData={MaterialList?.materialData}
            activityData={MaterialList?.activityData}
            materialActivityData={MaterialList?.materialActivityData}
          />
        </PageHeader>
      </Spin>
    </>

  )
}

export default Material
